import findAvailableLocale from 'models/helpers/findAvailableLocale';
import { selectLocale } from 'models/localization';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useFirebaseChatConfig from './useFirebaseChatConfig';

const usePublicChatroomName = (uniqueName: string): string | null => {
  const locale = useSelector(selectLocale);
  const { publicChatrooms } = useFirebaseChatConfig();

  return useMemo(() => {
    const chatroomConfig = publicChatrooms?.find((chatrooms) => chatrooms.id === uniqueName);
    if (!chatroomConfig) return null;
    return findAvailableLocale(chatroomConfig.label, locale);
  }, [locale, publicChatrooms, uniqueName]);
};

export default usePublicChatroomName;
